import React from 'react';
import { Field, FieldProps } from 'formik';
import { InputBase } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import { HandleBlur, HandleChange } from './types';

type Props = {
    handleBlur: HandleBlur;
    handleChange: HandleChange;
};

export const FieldMerchantName = ({ handleBlur, handleChange }: Props) => {
    const { t } = useTranslation();

    return (
        <Field name='merchantName'>
            {({ field }: FieldProps) => (
                <InputBase
                    id='merchant-name'
                    label={t('Merchant Name (Optional)')}
                    value={field.value ?? ''}
                    name='merchantName'
                    onChange={handleChange}
                    onBlur={handleBlur}
                    size='sm'
                    data-testid='add-merchant-name-field'
                    allowPan
                />
            )}
        </Field>
    );
};

export default FieldMerchantName;
